// src/components/ProfileDropdown.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import Button from './Button';
import './ProfileDropdown.css';
import { useAuth } from '../contexts/AuthContext';

const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser } = useAuth(); // Use centralized auth context
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("User signed out successfully");

      // Clear API cache on logout to prevent data leakage
      if (typeof window !== 'undefined') {
        const { clearCache } = await import('../utils/apiHelpers');
        clearCache();
      }

      setIsOpen(false);
      navigate('/');
    } catch (error) {
      console.error("Error signing out: ", error);
      alert("Failed to sign out. Please try again.");
    }
  };

  if (!currentUser) return null;

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const appVersion = process.env.REACT_APP_VERSION || '0.1.0';

  return (
    <div className="profile-dropdown" ref={dropdownRef}>
      <button
        className="profile-avatar-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Profile menu"
      >
        {currentUser.photoURL ? (
          <img src={currentUser.photoURL} alt="Profile" className="profile-avatar-img" />
        ) : (
          <div className="profile-avatar-initials">
            {getInitials(currentUser.displayName)}
          </div>
        )}
      </button>

      {isOpen && (
        <div className="profile-dropdown-menu">
          <div className="profile-dropdown-header">
            <div className="profile-dropdown-name">{currentUser.displayName || 'User'}</div>
            <div className="profile-dropdown-email">{currentUser.email}</div>
          </div>
          <div className="profile-dropdown-divider"></div>
          <Button onClick={handleLogout} className="profile-dropdown-logout">
            Logout
          </Button>
          <div className="profile-dropdown-version">v{appVersion}</div>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
